import { createApp } from 'vue';

window.addEventListener('DOMContentLoaded', function () {
    $('.menu-toggle').click(function () {
        $(this).siblings('#nav-mega-menu').slideToggle('slow');
    });
    $('.top-menu.mobile .sublist-toggle').click(function () {
        $(this).siblings('.sublist').slideToggle('slow');
    });
});

const TreeElements = {
    template: '#tree-template',
    props: [
        'url',
        'title',
        'children'
    ],
    data: function () {
        return {
            depth: 0,
            currentPath: window.location.pathname,
        }
    },
    methods: {
        hasChildren: function (children) {
            return Array.isArray(children) && children.length > 0;
        },
        isPathActive: function (path) {
            let currentPathWithoutLanguagePrefix = this.currentPath.replace(/^\/[^/]+\//, '/');
            return currentPathWithoutLanguagePrefix === path || path === this.currentPath;
        }
    }
};

const app = createApp({
    data() {
        return {
            activeParent: '',
            selectedTree: [],
            menuTree: menuItems,
            currentPath: window.location.pathname,
        };
    },
    methods: {
        isActiveMenuItem: function (menuItem) {
            return this.selectedTree === menuItem
        },
        isSubmenuElementActive: function (selectedTree) {
            return selectedTree.Children?.some((item) => this.isPathActive(item.Url));
        },
        setActiveMenuItem: function (selectedTree) {
            if (this.selectedTree === selectedTree) {
                this.selectedTree = ''
            } else {
                this.activeParent = selectedTree.Title
                this.selectedTree = selectedTree
            }
        },
        clickOutsideMenu: function (e) {
            var el = document.getElementById('nav-mega-menu')
            var target = e.target
            if ((el !== target) && !el?.contains(target)) {
                this.selectedTree = ''
            }
        },
        changeLanguage: function (langId, langUniqueSeoCode) {
            window.location.replace("/" + langUniqueSeoCode + "/changelanguage/" + langId + "?returnurl=" + encodeURIComponent(window.location.pathname + window.location.search));
        },
        isPathActive: function (path) {
            let currentPathWithoutLanguagePrefix = this.currentPath.replace(/^\/[^/]+\//, '/');
            return currentPathWithoutLanguagePrefix === path || path === this.currentPath;
        }
    },
    created: function () {
        document.addEventListener('click', this.clickOutsideMenu)
    },
    unmounted: function () {
        document.removeEventListener('click', this.clickOutsideMenu)
    }
});

app.component('tree-elements', TreeElements);
app.mount('#nav-mega-menu');